import { ApolloError } from '@apollo/client';
import { FormApi } from 'final-form';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { getErrorMessage } from '@occc/utils';

import { LocationUpdateFormData } from './types';

/**
 * A location update can fail because the location no longer exists / is not provisioned
 * (AC8). Detect that case from the GraphQL error code or message.
 */
export const isLocationNotFoundError = (error: ApolloError): boolean =>
  /not found/i.test(error.message) ||
  error.graphQLErrors.some(
    (gqlError) => gqlError.extensions?.code === 'NOT_FOUND' || /not found/i.test(gqlError.message),
  );

export const getLocationUpdateErrorMessage = (error: ApolloError): string =>
  isLocationNotFoundError(error) ? 'Location not found' : getErrorMessage(error);

/**
 * AC9: a failed save applies no changes, so revert the scan-data toggles (RJR Auto Offers and
 * Altria P+) to their last persisted states (each field's initial value). Toggling one must not
 * affect the other, so each is reverted independently.
 */
export const revertScanDataToggles = (form: FormApi<LocationUpdateFormData>): void => {
  const { initialValues } = form.getState();
  form.change('rjrAutoOffersEnabled', initialValues?.rjrAutoOffersEnabled);
  form.change('altriaPPlusApiEnabled', initialValues?.altriaPPlusApiEnabled);
};
